import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { IdentityApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [],
})
export class IdentityApiModule {
  public static forRoot(
    configurationFactory: () => IdentityApiConfiguration,
  ): ModuleWithProviders<IdentityApiModule> {
    return {
      ngModule: IdentityApiModule,
      providers: [{ provide: IdentityApiConfiguration, useFactory: configurationFactory }],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: IdentityApiModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error('IdentityApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
